import {
  PortOrder,
} from '@proto/odoo/sessionkv';

export type PortOrderDraft = {
    name: string;
    portOrder: PortOrder;
}

export class SessionKvPortOrder {
  private portOrder: PortOrder = PortOrder.create({});

  constructor() {}

  /**
   * Set basic data
   */
  setBasicData(data: {
    applianceId: number;
    contactId?: number;
    losingProvider: string;
  }): this {
    this.portOrder.applianceId = data.applianceId;
    this.portOrder.contactId = data.contactId ?? 0;
    this.portOrder.losingProvider = data.losingProvider;
    return this;
  }

  /**
   * Add single numbers
   */
  setSingleNumbers(data: {
    phoneNumbers: {
      countryPrefix: string;
      areaCode: string;
      number: string;
    }[];
  }): this {
    this.portOrder.numberBlocks = {
      $case: 'singleNumbers',
      singleNumbers: data
    };
    return this;
  }

  /**
   * Add number block
   */
  setNumberBlock(data: {
    countryPrefix: string;
    areaCode: string;
    mainNumber: string;
    blockStart: string;
    blockEnd: string;
  }): this {
    this.portOrder.numberBlocks = {
      $case: 'numberBlock',
      numberBlock: data
    };
    return this;
  }

  /**
   * Add file attachment
   */
  setFile(data: {
    assetKey: string;
  }): this {
    this.portOrder.losingProviderPhoneBill = data;
    return this;
  }

  /**
   * Get the final proto object
   */
  getProto(): PortOrder {
    return { ...this.portOrder };
  }
}
